module.exports = __webpack_public_path__ + "img/periodo.75845261.png";